
  export default {
    props: {
      articleEmbed: { type: Boolean, default: false },
      card: { type: Object, required: true }
    },
    computed: {
      path () {
        return this.localePath(`/compare-credit-cards/${this.card.institution.slug}/${this.card.code}/${this.card.slug}/`);
      }
    },
    methods: {
      saveToCookies () {
        const productCookie = {
          'institution': this.card.institution ? this.card.institution.name : '',
          'plan': this.card.name,
          'link': this.card.url ? this.card.url.link : ''
        };
        this.$cookies.set('bonkers-ie-selected-product', productCookie);
      }
    }
  };
